import React, { useRef, useEffect } from "react";
import { gsap } from "gsap";
import {isMobile} from 'react-device-detect';

const FadeInAnimation = ({
    children,
    wrapperElement = "div",
    direction = null,
    show,
    ...props
}) => {
    const Component = wrapperElement;
    let compRef = useRef(null);
    let distance = 460;
    let durationTime=2;
    if (isMobile){
        distance = 300;
    }
    useEffect(() => {
        gsap.fromTo(compRef.current, durationTime, {
            y: -80,
            opacity: 0.3,
        }, { opacity: 1, y: -distance, });
    }, [show]);

    if (show === true){
        return (
            <Component ref={compRef} {...props}>
                {children}
            </Component>
        );
    }
    else{
        return null
    }
};

export default FadeInAnimation;